module.exports = __webpack_public_path__ + "img/userNL.cd19e0d8.svg";